import { connect } from 'react-redux';
import { appActions } from 'app/app.actions';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { notificationActions } from '../../notifications/actions/notification';
import { presenceActions } from '../../presence/actions/presenceActions';
import * as personalActions from '../../settings/actions/personal';
import { hasFeature } from '../../shared/featureFlag';
import Profile from '../components/Profile';
const { notificationAdd, notificationRemoveByType } = notificationActions;
const { presenceSetStatus, presenceSetMedia, presenceSetMediaChannel, presenceSetSimultaneousRinging, } = presenceActions;
const { personalToggleRememberMicrophoneAccess } = personalActions.actions;
const mapStateToProps = (state) => {
    return {
        presenceMeta: state.presence.meta,
        profile: state.settings.profile.profile,
        organization: state.settings.organization.organization,
        telephony: state.telephony,
        presence: state.presence.presence,
        hasPhoneChannel: hasFeature(state, 'phone-channel'),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        presenceSetStatus: bindActionToPromise(dispatch, presenceSetStatus),
        presenceSetMedia: bindActionToPromise(dispatch, presenceSetMedia),
        presenceSetMediaChannel: bindActionToPromise(dispatch, presenceSetMediaChannel),
        presenceSetSimultaneousRinging: bindActionToPromise(dispatch, presenceSetSimultaneousRinging),
        notificationAdd: (payload) => dispatch(notificationAdd(payload)),
        notificationRemoveByType: (type) => dispatch(notificationRemoveByType({
            type,
        })),
        errorMicrophoneErrorShowModal: (payload) => dispatch(appActions.showModal({
            modal: {
                type: 'app:microphoneError',
                arg: Object.assign({}, ((payload === null || payload === void 0 ? void 0 : payload.name) && { error: payload.name })),
            },
        })),
        showLogoutModal: () => dispatch(appActions.showModal({
            modal: {
                type: 'app:logOut',
            },
        })),
        personalToggleRememberMicrophoneAccess: bindActionToPromise(dispatch, personalToggleRememberMicrophoneAccess),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
